import React, { useMemo, useRef } from 'react';
import { Table, FilterBuilder, Flex } from 'onefaceui-react-components';
import { useDispatch } from 'react-redux';
import { push } from 'connected-react-router';

import { getResourceTo } from 'react/utils/utils';

import { useDataSyncConfiguration } from 'react/queries/DataSyncConfiguration';
import EditIcon from 'static/images/monet/edit.svg';
import Loading from 'react/components/Loading';
import { Container } from './DataSyncConfiguration.styles';

export function DataSyncConfigurationList() {
  const dispatch = useDispatch();
  const tableRef = useRef(null);

  const { data = [], isFetching } = useDataSyncConfiguration();

  const tableColumns = [
    {
      title: getResourceTo('dataSyncConfiguration.fields.description'),
      field: 'name'
    },
    {
      title: getResourceTo('dataSyncConfiguration.fields.source'),
      field: 'source',
      formatter: (cell) => {
        const item = cell.getValue();

        return item.type;
      }
    },
    {
      title: getResourceTo('dataSyncConfiguration.fields.destination'),
      field: 'destination',
      formatter: (cell) => {
        const item = cell.getValue();

        return item.type;
      }
    },
    {
      title: getResourceTo('dataSyncConfiguration.fields.status'),
      field: 'status',
      formatter: (cell) => {
        const value = cell.getValue();

        if (value) {
          return '<div class="gridCheckboxTrue"></div>';
        }

        return '<div class="gridCheckboxFalse"></div>';
      }
    }
  ];

  const tableActions = useMemo(() => {
    const actions = {
      customizeColumns: true
    };

    if (Monet.Security.checkKeyIsEnabled(['AUTHENTICATIONMETHOD_CREATE']) && !data.length) {
      actions.create = () => {
        dispatch(push('/DataSyncConfiguration/new'));
      };
    }

    return actions;
  }, [data.length]);

  const tableCustomColumns = useMemo(() => {
    const columns = [];

    if (Monet.Security.checkKeyIsEnabled(['AUTHENTICATIONMETHOD_UPDATE'])) {
      columns.push({
        width: 50,
        field: 'edit',
        frozen: true,
        headerSort: false,
        hozAlign: 'center',
        formatter() {
          return `<img src=${EditIcon} class="edit-icon" alt="Edit Icon" />`;
        },
        cellClick(_, cell) {
          const { id } = cell.getRow().getData();
          dispatch(push(`/DataSyncConfiguration/edit/${id}`));
        }
      });
    }

    return columns;
  }, []);

  return (
    <Container data-testid="data-sync-configuration-list">
      <FilterBuilder
        onSubmit={() => null}
        fields={[]}
      />
      <Flex shouldShow={isFetching} justifyContent="center">
        <Loading width="100px" height="100px" />
      </Flex>
      <Flex shouldShow={!isFetching} className="oneface-table-container">
        <Table
          isLoading={isFetching}
          ref={tableRef}
          defaultData={data}
          headerOptions={{
            showResults: true,
            actions: tableActions
          }}
          customColumns={tableCustomColumns}
          columns={tableColumns}
          columnsPreference={tableColumns}
        />
      </Flex>
    </Container>
  );
}
